import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-consultant-private-conversation',
  templateUrl: './consultant-private-conversation.component.html',
})
export class ConsultantPrivateConversationComponent implements OnInit {
  private servicetype: string;
  private setfilter: boolean;

  constructor() { }

  ngOnInit(): void {
    this.servicetype = 'Conversation';
    this.setfilter = false;
  }

}
